import { createRouteConfig } from 'modules/router/utils/createRouteConfig';
import { IPaymentFormValues } from 'modules/payments/types';
import { useQueryParams } from 'modules/common/hooks/useQueryParams';

const PATH_CHECKOUT = '/checkout/';

const generatePath = (params?: Partial<IPaymentFormValues>) =>
  `${PATH_CHECKOUT}?${new URLSearchParams(params).toString()}`;

export const checkoutRoutesConfig = createRouteConfig(
  {
    checkout: {
      path: PATH_CHECKOUT,
      generatePath: (params?: Partial<IPaymentFormValues>) =>
        generatePath(params),
      useQuery: () => {
        const search = useQueryParams();
        const entries = search.entries();

        return Object.fromEntries(entries) as unknown as IPaymentFormValues;
      },
    },
  },
  PATH_CHECKOUT,
);
